import { render, staticRenderFns } from "./NeoporezivoVisak.vue?vue&type=template&id=016a60dd&scoped=true"
import script from "./NeoporezivoVisak.vue?vue&type=script&lang=js"
export * from "./NeoporezivoVisak.vue?vue&type=script&lang=js"
import style0 from "./NeoporezivoVisak.vue?vue&type=style&index=0&id=016a60dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a60dd",
  null
  
)

export default component.exports